import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "m6.55 2.717.677-.677h5.416l.677.677v2.708h3.384v1.354h-.73l-.852 10.21-.674.621H5.422l-.675-.62-.851-10.211h-.73V5.425H6.55V2.717Zm1.354.677v2.03h4.062v-2.03H7.904Zm6.71 3.385h-9.36l.79 9.477h7.78l.79-9.477ZM6.753 8.133l.355 6.77h1.016l-.354-6.77H6.753Zm2.675 6.77h1.015v-6.77H9.428v6.77Zm2.318 0h1.017l.355-6.77H12.1l-.355 6.77Z",
    fill: "#D5D4D6"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h20v20H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }